var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Container, ContainerBackgroundVariants, ContainerDisplays, ContainerFlexAlignItems, ContainerFlexGaps, ContainerPaddings } from '../../../../templates/container';
import { Image } from '../../../../atoms/image';
import { Text, TextVariants } from '../../../../atoms/text';
var DI = function (_a) {
    var props = __rest(_a, []);
    var image = props.image, content = props.content;
    var containerConfig = {
        backgroundTheme: ContainerBackgroundVariants.Main,
        padding: ContainerPaddings.Size_3,
        display: ContainerDisplays.Flex,
        flexGap: ContainerFlexGaps.Size_3,
        flexAlignItems: ContainerFlexAlignItems.Strecth
    };
    var imageContainer = __assign(__assign({}, image), { alt: '' });
    var contentConfig = {
        content: content,
        isHtml: true,
        variant: TextVariants.Body2
    };
    var textWrapperConfig = {
        display: ContainerDisplays.Flex,
        flexAlignItems: ContainerFlexAlignItems.Center
    };
    return (React.createElement(Container, __assign({}, containerConfig),
        image && React.createElement(Image, __assign({}, imageContainer)),
        content && (React.createElement(Container, __assign({}, textWrapperConfig),
            React.createElement(Text, __assign({}, contentConfig))))));
};
export { DI as DeliveryInfo };
